/**
 * Badge catalog — add new entries here to introduce new badges.
 * Each badge: { code, name, description, image, category, threshold, [celebration_video] }
 *
 * categories:
 *  - "milestone"  → total lifetime workouts (sun-themed art)
 *  - "streak"     → consecutive-day workout streaks (flame-themed art)
 */
export const BADGE_CATALOG = {
  // ============ MILESTONES (lifetime workouts) ============
  workouts_25: {
    code: 'workouts_25',
    name: 'Rising Sun',
    description: 'Completed 25 workouts',
    image: '/badges/rising-sun.png',
    category: 'milestone',
    threshold: 25,
    celebration_video: 'https://customer-assets.emergentagent.com/job_72221763-1df9-4e68-af5e-f11ec1fb708e/artifacts/w6q4fim4_06ccfc60-3ec6-11f1-8443-7d00c1ed8f7f.mp4',
  },
  workouts_50: {
    code: 'workouts_50',
    name: 'Solar Burst',
    description: 'Completed 50 workouts',
    image: '/badges/solar-burst.png',
    category: 'milestone',
    threshold: 50,
    celebration_video: 'https://customer-assets.emergentagent.com/job_72221763-1df9-4e68-af5e-f11ec1fb708e/artifacts/r79f7y1r_407fd710-3ec7-11f1-8443-7d00c1ed8f7f.mp4',
  },
  workouts_75: {
    code: 'workouts_75',
    name: 'Solar Flare',
    description: 'Completed 75 workouts',
    image: '/badges/solar-flare.png',
    category: 'milestone',
    threshold: 75,
    celebration_video: 'https://customer-assets.emergentagent.com/job_72221763-1df9-4e68-af5e-f11ec1fb708e/artifacts/jbk2heek_8cda75d0-3ec6-11f1-8443-7d00c1ed8f7f.mp4',
  },
  workouts_100: {
    code: 'workouts_100',
    name: 'Diamond Halo',
    description: 'Completed 100 workouts',
    image: '/badges/diamond-halo.png',
    category: 'milestone',
    threshold: 100,
    celebration_video: 'https://customer-assets.emergentagent.com/job_72221763-1df9-4e68-af5e-f11ec1fb708e/artifacts/0alfujfn_VID-20260423-WA0031.mp4',
  },
  workouts_150: {
    code: 'workouts_150',
    name: 'Cosmic Nova',
    description: 'Completed 150 workouts',
    image: '/badges/cosmic-nova.png',
    category: 'milestone',
    threshold: 150,
    celebration_video: 'https://customer-assets.emergentagent.com/job_72221763-1df9-4e68-af5e-f11ec1fb708e/artifacts/27qca9n3_VID-20260423-WA0009.mp4',
  },

  // ============ STREAKS (consecutive workout days) ============
  streak_3: {
    code: 'streak_3',
    name: 'Spark',
    description: '3-day workout streak',
    image: '/badges/streak-spark.png',
    category: 'streak',
    threshold: 3,
  },
  streak_7: {
    code: 'streak_7',
    name: 'Kindle',
    description: '7-day workout streak',
    image: '/badges/streak-kindle.png',
    category: 'streak',
    threshold: 7,
  },
  streak_14: {
    code: 'streak_14',
    name: 'Wildfire',
    description: '14-day workout streak',
    image: '/badges/streak-wildfire.png',
    category: 'streak',
    threshold: 14,
  },
  streak_30: {
    code: 'streak_30',
    name: 'Phoenix',
    description: '30-day workout streak',
    image: '/badges/streak-phoenix.png',
    category: 'streak',
    threshold: 30,
  },
  streak_90: {
    code: 'streak_90',
    name: 'Eternal Flame',
    description: '90-day workout streak',
    image: '/badges/streak-eternal-flame.png',
    category: 'streak',
    threshold: 90,
  },
};

export const getBadgeMeta = (code) => BADGE_CATALOG[code] || null;
